// extracted by mini-css-extract-plugin
module.exports = {"corrected-search-term":"CorrectedSearchTerm_corrected-search-term__YuCbT","corrected-search-term__copy":"CorrectedSearchTerm_corrected-search-term__copy__pWT5M"};